var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "AddLabourForm",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          var errors = ref.errors
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.editEquipment($event)
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Equipment Code",
                              "label-for": "mc-first-name",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Equipment Code",
                                vid: "Equipment Code",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-first-name",
                                            placeholder: "Equipment Code",
                                          },
                                          model: {
                                            value: _vm.equipment.assetCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.equipment,
                                                "assetCode",
                                                $$v
                                              )
                                            },
                                            expression: "equipment.assetCode",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Equipment Name",
                              "label-for": "mc-last-name",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Equipment Name",
                                vid: "Equipment Name",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-last-name",
                                            placeholder: "Equipment Name",
                                          },
                                          model: {
                                            value: _vm.equipment.name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.equipment,
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression: "equipment.name",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Equipment Description",
                              "label-for": "mc-city",
                            },
                          },
                          [
                            _c("b-form-textarea", {
                              attrs: {
                                id: "textarea-default",
                                placeholder: "Equipment Description",
                                rows: "3",
                              },
                              model: {
                                value: _vm.equipment.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.equipment, "description", $$v)
                                },
                                expression: "equipment.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Supplier",
                              "label-for": "mc-Supplier",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.suppliers,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              model: {
                                value: _vm.equipment.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.equipment, "supplierId", $$v)
                                },
                                expression: "equipment.supplierId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "Staff", "label-for": "mc-Staff" },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.staffOptions,
                                "value-field": "id",
                                "text-field": "firstName",
                              },
                              model: {
                                value: _vm.equipment.staffId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.equipment, "staffId", $$v)
                                },
                                expression: "equipment.staffId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Purchase Date",
                              "label-for": "mc-purchase",
                            },
                          },
                          [
                            _c("b-form-datepicker", {
                              staticClass: "mb-1",
                              attrs: { id: "example-purchase" },
                              model: {
                                value: _vm.equipment.purchaseDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.equipment, "purchaseDate", $$v)
                                },
                                expression: "equipment.purchaseDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Expiry Date",
                              "label-for": "mc-expiry",
                            },
                          },
                          [
                            _c("b-form-datepicker", {
                              staticClass: "mb-1",
                              attrs: { id: "example-expiry" },
                              model: {
                                value: _vm.equipment.lifeEndDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.equipment, "lifeEndDate", $$v)
                                },
                                expression: "equipment.lifeEndDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Maintenance Date",
                              "label-for": "mc-maintainance",
                            },
                          },
                          [
                            _c("b-form-datepicker", {
                              staticClass: "mb-1",
                              attrs: { id: "example-maintainance" },
                              model: {
                                value: _vm.equipment.maintainanceDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.equipment,
                                    "maintainanceDate",
                                    $$v
                                  )
                                },
                                expression: "equipment.maintainanceDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "5" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Location",
                              "label-for": "mc-last-name",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "mc-last-name",
                                placeholder: "Location",
                              },
                              model: {
                                value: _vm.equipment.location,
                                callback: function ($$v) {
                                  _vm.$set(_vm.equipment, "location", $$v)
                                },
                                expression: "equipment.location",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Availability",
                              "label-for": "mc-last-name",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.optionsDLL },
                              on: {
                                change: function ($event) {
                                  return _vm.addNote(_vm.equipment.status)
                                },
                              },
                              model: {
                                value: _vm.equipment.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.equipment, "status", $$v)
                                },
                                expression: "equipment.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-end",
                        attrs: { md: "3" },
                      },
                      [
                        _c(
                          "b-form-group",
                          { staticStyle: { "margin-top": "20px" } },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEquipmentDocBtn(
                                      _vm.equipment.id
                                    )
                                  },
                                },
                              },
                              [_vm._v("Documents")]
                            ),
                            _vm.loading
                              ? _c("b-spinner", {
                                  staticClass: "mt-1",
                                  staticStyle: {
                                    width: "3rem",
                                    height: "3rem",
                                    "margin-left": "32px",
                                  },
                                  attrs: {
                                    variant: "success",
                                    label: "Spinning",
                                    block: "",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "b-modal",
                          {
                            ref: "modal-view-equipment-document",
                            attrs: {
                              id: "modal-view-equipment-document",
                              "ok-only": "",
                              "ok-title": "View",
                              centered: "",
                              size: "lg",
                              title: "View Equipment Documents",
                              "hide-footer": true,
                            },
                          },
                          [
                            _c("DocumentUpload", {
                              attrs: { documentDetails: _vm.documentDetails },
                              on: {
                                deleteFile: _vm.deleteFile,
                                downloadFile: _vm.downloadFile,
                                uploadFiles: _vm.uploadFiles,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Cost Per Hour" } },
                          [
                            _c("b-form-input", {
                              attrs: {
                                type: "number",
                                placeholder: "Cost / Hour (RS)",
                                step: "0.01",
                                required: "",
                              },
                              model: {
                                value: _vm.equipment.costPerHour,
                                callback: function ($$v) {
                                  _vm.$set(_vm.equipment, "costPerHour", $$v)
                                },
                                expression: "equipment.costPerHour",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-end",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              type: "button",
                              variant: "primary",
                              disabled: invalid,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addNote(_vm.defaultAddNoteStatus)
                              },
                            },
                          },
                          [_vm._v("Add notes")]
                        ),
                      ],
                      1
                    ),
                    _vm.equipment.notes && _vm.equipment.notes.length > 0
                      ? _c(
                          "b-col",
                          { staticClass: "mt-2", attrs: { md: "12" } },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "my-1",
                                attrs: { md: "3", sm: "4" },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  { staticClass: "mb-0" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "d-inline-block text-sm-left mr-50",
                                      },
                                      [_vm._v("Per page")]
                                    ),
                                    _c("b-form-select", {
                                      staticClass: "w-50",
                                      attrs: {
                                        id: "perPageSelect",
                                        size: "sm",
                                        options: _vm.pageOptions,
                                      },
                                      model: {
                                        value: _vm.perPage,
                                        callback: function ($$v) {
                                          _vm.perPage = $$v
                                        },
                                        expression: "perPage",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("b-table", {
                              attrs: {
                                striped: "",
                                hover: "",
                                responsive: "",
                                "per-page": _vm.perPage,
                                "current-page": _vm.currentPage,
                                items: _vm.equipment.notes,
                                fields: _vm.noteFields,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "cell(user)",
                                    fn: function (data) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(data.item.user)),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(note)",
                                    fn: function (data) {
                                      return [
                                        _vm.isEditable(data.item)
                                          ? _c("validation-provider", {
                                              attrs: {
                                                rules: "required",
                                                label: "Note",
                                                vid: data.item.id,
                                                name: "Note",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "Enter notes",
                                                          },
                                                          model: {
                                                            value:
                                                              data.item.note,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                data.item,
                                                                "note",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "data.item.note",
                                                          },
                                                        }),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            })
                                          : _c("b-form-input", {
                                              attrs: {
                                                readonly: !_vm.isEditable(
                                                  data.item
                                                ),
                                                placeholder: "Enter notes",
                                              },
                                              model: {
                                                value: data.item.note,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    data.item,
                                                    "note",
                                                    $$v
                                                  )
                                                },
                                                expression: "data.item.note",
                                              },
                                            }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(noteDate)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(data.item.noteDate)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("b-pagination", {
                                  staticClass: "my-0",
                                  attrs: {
                                    "total-rows": _vm.equipment.notes.length,
                                    "per-page": _vm.perPage,
                                    align: "center",
                                    size: "sm",
                                  },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function ($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-between",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              disabled: _vm.loading,
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", {
                                  staticClass: "mx-2",
                                  attrs: { small: "" },
                                })
                              : _vm._e(),
                            _vm._v("Submit"),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }